import { CSSProperties, PropsWithChildren } from "react";

const TableRow = (
  props: PropsWithChildren<{
    style?: CSSProperties;
    className?: string;
    selected?: boolean;
    onClick?: () => void;
  }>
) => (
  <article
    {...props}
    className={
      props.className +
      " grid items-center py-5 pl-11" +
      (props.onClick !== undefined
        ? " hover:cursor-pointer hover:bg-ctb-blue-0"
        : "") +
      (props.selected ? " bg-ctb-blue-0" : "")
    }
  />
);

export default TableRow;
